import { http } from './http';

export interface TokensResponse {
  accessToken: string;
  refreshToken: string;
  customerId: string;
  sessionId: string;
  refreshExpiresAt: string;
}

export interface RequestIdResponse {
  requestId: string;
}

export const authApi = {
  registerPhone(payload: {
    phoneE164: string;
    legalFirstName: string;
    legalLastName: string;
    legalCountry: string;
    preferredLanguage?: string;
  }) {
    return http.post<RequestIdResponse>('/v1/auth/register/phone', payload).then(r => r.data);
  },

  verifyRegistrationPhone(payload: {
    requestId: string;
    code: string;
    deviceFingerprint?: string;
  }) {
    return http.post<TokensResponse>('/v1/auth/register/verify-phone', payload).then(r => r.data);
  },

  loginPhone(phoneE164: string) {
    return http.post<RequestIdResponse>('/v1/auth/login/phone', { phoneE164 }).then(r => r.data);
  },

  loginVerify(payload: {
    requestId: string;
    smsCode?: string;
    emailCode?: string;
    deviceFingerprint?: string;
  }) {
    return http.post<TokensResponse>('/v1/auth/login/verify', payload).then(r => r.data);
  },

  // No body — refresh token rides in the HttpOnly cookie (withCredentials).
  refresh() {
    return http.post<TokensResponse>('/v1/auth/token/refresh').then(r => r.data);
  },

  logout() {
    return http.post('/v1/auth/logout');
  },

  setupPassword(password: string) {
    return http.post('/v1/auth/password/setup', { password });
  },

  verifyPassword(password: string) {
    return http
      .post<{ ok: boolean; status: string }>('/v1/auth/password/verify', { password })
      .then(r => r.data);
  },

  changePassword(oldPassword: string, newPassword: string) {
    return http
      .post<{ status: string; hint?: string }>('/v1/auth/password/change', { oldPassword, newPassword })
      .then(r => r.data);
  },

  resetPassword(password: string) {
    return http
      .post<{ status: string; vaultEntriesInvalidated: number; nextAction: string }>(
        '/v1/auth/password/reset',
        { password },
      )
      .then(r => r.data);
  },
};
